import { useEffect, useId } from 'react';
import { useCommandStore } from '../store';

export const useCommands = <T extends { type: string }>(
  types: string[],
  callback: (commands: T[]) => void
) => {
  const id = useId();
  const subscribe = useCommandStore((state) => state.subscribe);
  const unsubscribe = useCommandStore((state) => state.unsubscribe);

  useEffect(() => {
    subscribe({ id, types, callback: callback as any });

    return () => {
      unsubscribe(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);
};

export const useCommand = <T extends { type: string }>(
  type: string,
  callback: (commands: T[]) => void
) => {
  const id = useId();
  const subscribe = useCommandStore((state) => state.subscribe);
  const unsubscribe = useCommandStore((state) => state.unsubscribe);

  useEffect(() => {
    subscribe({ id, type, callback: callback as any });

    return () => {
      unsubscribe(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);
};
